import React, { Component } from 'react';
import ProfilePlaceholder   from 'assets/icons/profile-placeholder.png';
import { ClaimDetails }     from 'components/ClaimDetails/ClaimDetails';
import { CreateClaim }      from 'components/ClaimDetails/CreateClaim';
import { formatCurrency }   from 'helpers/common.helper';
import moment               from 'moment';

export class ClaimsCards extends Component {
  render() {
    const colorHash   = { 'Approved': 'success', 'Rejected': 'primary', 'Pending Submissions': 'warning', 'Pending Approval': 'grey', 'Paid': 'success' };
    const statusHash  = { 'approved': 'Approved', 'not_submitted': 'Pending Submissions', 'draft': 'Pending Submissions', 'under_review': 'Pending Submissions', 'pending': 'Pending Approval', 'under_approval_review': 'Pending Approval', 'rejected': 'Rejected' };
    const catHash     = { 'general': 'Medical', 'gp': 'Medical', 'specialist': 'Specialist', 'dental': 'Dental', 'optical': 'Optical', 'ehs': 'EHS' };
    const today       = moment().format('DD MMM YYYY');

    const patientCards = this.props.items.map((hash, index) => {
      const displayedStatus = hash.paid ? 'Paid' : statusHash[hash.status];
      const color           = colorHash[displayedStatus];
      const displayedDate   = hash.date === today ? 'Today' : hash.date;
      const category        = catHash[hash.category];
      let actionButton;

      if (displayedStatus === 'Pending Submissions') {
        actionButton = <CreateClaim data={ hash } status={ displayedStatus } color={ color } category={ category } triggerReload={() => this.props.handleReload() } />;
      } else {
        actionButton = <ClaimDetails data={ hash } status={ displayedStatus } color={ color } category={ category } />;
      }

      return (
        <tr key={ hash.id } className="patient-card-row bg-white" value={ hash.status }>
          {/* Desktop View */}
            <td valign="top" className={ 'd-none d-lg-table-cell py-6 px-4 border-' + color }>
              <p className="fweight-500 font-size-6 mb-2">{ displayedDate }</p>
              <span className="font-size-4 mb-0">Ref No.: { hash.id }</span>
            </td>

            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">
              <div className="d-flex align-items-center">
                <img src={ ProfilePlaceholder } alt="profile" className="profile-placeholder mr-4"/>

                <span>
                  <p className="mb-1 font-size-6 fweight-500">{ hash.personal_info.policy_owner }</p>
                  <p className="mb-0 font-size-5 fweight-400 text-grey">{ hash.personal_info.company_name }</p>
                  <a href="derp" className="text-danger d-none">View Profile</a>
                </span>
              </div>
            </td>

            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">{ category }</td>
            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">{ 'MYR ' + formatCurrency(hash.total_amount) }</td>
            <td valign="top" className={ 'd-none d-lg-table-cell py-6 pr-4 text-' + color }><b>{ displayedStatus }</b></td>
            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">{ actionButton }</td>

          {/* Mobile View */}
            <td colSpan="6" valign="top" className={ 'd-table-cell d-lg-none font-size-7 py-6 pl-6 border-' + color }>
              <div className="d-flex justify-content-between mt-2 mb-2">
                <p className="mb-0 flex-grow-1">
                  <b className="d-inline-block w-em-15 font-size-6">{ displayedDate }</b>
                </p>

                <b className={ 'text-right text-' + color}>{ displayedStatus }</b>
                { actionButton }
              </div>

              <div className="d-flex align-items-center mb-4">
                <img src={ ProfilePlaceholder } alt="profile" className="profile-placeholder mr-4"/>

                <span>
                  <p className="mb-1 font-size-6 fweight-500">{ hash.personal_info.policy_owner }</p>
                </span>
              </div>

              <div className="d-flex align-items-end justify-content-between mb-0 mr-8">
                <div>
                  <span className="d-inline-block w-em-12">Category:</span>
                  <b>{ category }</b><br/>
                  <span className="d-inline-block w-em-12">Company:</span>
                  <b>{ hash.personal_info.company_name }</b><br/>
                  <span className="d-inline-block w-em-12">Total Bill:</span>
                  <b>{ 'MYR ' + formatCurrency(hash.total_amount) }</b>
                </div>

                <span className="font-size-3 mb-0">Ref No.: { hash.id }</span>
              </div>
            </td>
        </tr>
      )
    });

    var dateRange;

    if (this.props.startDateDisplay && this.props.endDateDisplay) {
      dateRange = 'No claims between ' + this.props.startDateDisplay + ' - ' + this.props.endDateDisplay;
    } else {
      dateRange = 'No claims'
    }

    const emptyHolder   = <tr className="patient-card-row bg-white">
      <td colSpan="6" className="text-center font-size-7 fweight-500 py-4" style={{ borderRadius: "0.5em" }}>{ dateRange }</td>
    </tr>;

    const displayCards  = patientCards.length > 0 ? patientCards : emptyHolder;

    return (
      <table id="dashboard-cards-table" className="w-100">
        <thead className="d-none d-lg-table-header-group">
          <tr>
            {
              ['Date', 'Patient Profile', 'Category', 'Bill Amount', 'Status', 'Actions'].map((name, index) => {
                const padding = index > 0 ? 'pr-4' : 'px-4';
                return <th key={ 'table-header-' + name } className={ "font-size-7 fweight-500 " + padding }>{ name }</th>
              })
            }
          </tr>
        </thead>

        <tbody>
          { displayCards }
        </tbody>
      </table>
    )
  }
}